//Collection page scripts
//Onload & click custom script for  collection inner banner add between product items
$(function(){
 var $insert_position,
  	  $plus_addition,
      $adcl,
      $position,
      $position_loop,
      $loop_inc;

  resize();


  $(document).on('click', '[data-action="change-layout-mode"]', function(){
    //console.log($(this).data("count"));
      $insert_position = $(".insert_position").val();
      $count = $(this).data("count");
      $(".inner_append").remove();
  		$position_loop = 1;

        $(".insert_position").each(function(){
          $loop_inc = 1;
          $insert_position = $(this).val();
          var data_loop = $(this).attr("data-loop");
          $(".ProductList .Grid__Cell").each(function(){
            if($adcl == 1){
              $plus_addition = $insert_position * $adcl;
              $position = $plus_addition + 1;
            }
            if($adcl == 2){
              $plus_addition = $insert_position * $adcl;
              $position = $plus_addition + 1;
            }else if($adcl == 3){
              $plus_addition = $insert_position * $adcl;
              $position = $plus_addition + 1;
            }
            if($position == $loop_inc){
              var inner_data = $(".inner_banner_section_"+data_loop).removeClass("hidden").html();
              $('<div class="inner_append inner_banner_section_'+data_loop+'">'+inner_data+"</div>").insertBefore(this);
              $(".ProductList").find(".inner_append").children(".banners").removeClass("hidden");
            }
    		$loop_inc++;
          });
          $position_loop++;
        });
        $('.ProductItem__Carousel').flickity('resize'); // Resize the carousels on collection page

  });

  $(window).on('resize', function(){
    resize();
  });

});

function resize(){
  var $insert_position,
  	  $plus_addition,
      $adcl,
      $position,
      $position_loop,
      $loop_inc;
      // collection full width banner insert after the position
      $(".ProductList").find(".banners").remove();
      $insert_position = $(".insert_position").val();
      if (window.matchMedia("(max-width: 767px)").matches){
        $adcl = $(".hidden-tablet-and-up .is-active").attr("data-count");
        //console.log("This is a mobile device.");
      }else{
         //console.log("This is a tablet or desktop.");
        $adcl = $(".hidden-phone .is-active").attr("data-count");
      }
        /* if($adcl == 1){
              $plus_addition = $insert_position * $adcl;
              $position = $plus_addition + 1;
        }
        if($adcl == 2){
          $plus_addition = $insert_position * $adcl;
          $position = $plus_addition + 1;
        }else if($adcl == 3){
          $plus_addition = $insert_position * $adcl;
          $position = $plus_addition + 1;
        }

       $loop_inc = 1;
      $(".ProductList .Grid__Cell").each(function(){
         if($position_click == $loops){
              var inner_data = $(".inner_banner_section").html();
              $(inner_data).insertBefore(this);
              $(".ProductList").find(".banners").removeClass("hidden");
          }
       $loop_inc++;
      });*/
        $(".inner_append").remove();
  		$position_loop = 1;
        $(".insert_position").each(function(){
          $loop_inc = 1;
          $insert_position = $(this).val();
          var data_loop = $(this).attr("data-loop");
          $(".ProductList .Grid__Cell").each(function(){
            if($adcl == 1){
              $plus_addition = $insert_position * $adcl;
              $position = $plus_addition + 1;
            }
            if($adcl == 2){
              $plus_addition = $insert_position * $adcl;
              $position = $plus_addition + 1;
            }else if($adcl == 3){
              $plus_addition = $insert_position * $adcl;
              $position = $plus_addition + 1;
            }
            if($position == $loop_inc){
              var inner_data = $(".inner_banner_section_"+data_loop).removeClass("hidden").html();
              $('<div class="inner_append inner_banner_section_'+data_loop+'">'+inner_data+"</div>").insertBefore(this);
              $(".ProductList").find(".inner_append").children(".banners").removeClass("hidden");
            }

            /*if($position == $loop_inc){
              var inner_data = $(".inner_banner_section_"+$position).removeClass("hidden").html();
              $('<div class="inner_append inner_banner_section_'+$position+'">'+inner_data+"</div>").insertBefore(this);
              $(".ProductList").find(".inner_append").children(".banners").removeClass("hidden");
            }*/
            $loop_inc++;
          });
          $position_loop++;
        });

}


/* Mobile filter sticky */

/*
function sticky_filter() {
  if (window.matchMedia("(max-width: 767px)").matches){
    var window_top = $(window).scrollTop();
    var div_top = $('#collection_mobile_sticky_head').offset().top;
    if (window_top > div_top) {
      $('.CollectionToolbar--top').addClass('stick_collection');
    } else {
      $('.CollectionToolbar--top').removeClass('stick_collection');
    }
  }
}

$(function() {
  $(window).scroll(sticky_filter);
  sticky_filter();
});

*/

/* collection sort */

/*
$(function() {
  var $attr;
  $(".CollectionToolbar__Item--sort").click(function(){
    if (window.matchMedia("(max-width: 767px)").matches){
    }else{
      $attr = $(this).attr('aria-expanded');
      if ($attr == "false") {
           $(this).attr("aria-expanded", true);
           $("#collection-sort-popover").attr("aria-hidden",false);
           $("#collection-sort-popover").attr("tabindex",-1);
      }else{
           $(this).attr("aria-expanded", false);
           $("#collection-sort-popover").attr("aria-hidden",true);
           $("#collection-sort-popover").attr("tabindex",0);
      }

    }
  });
  $("#collection-sort-popover, Popover__Close").click(function(){
    $(".CollectionToolbar__Item--sort").attr("aria-expanded", false);
    $("#collection-sort-popover").attr("aria-hidden",true);
    $("#collection-sort-popover").attr("tabindex",0);
  });
});

*/

/* Accordion Filter collection */
$(function() {
		var Accordion = function(el, multiple) {
				this.el = el || {};
				this.multiple = multiple || false;

				var links = this.el.find('.filter-group h4');
				links.on('click', {
						el: this.el,
						multiple: this.multiple
				}, this.dropdown)
		}

		Accordion.prototype.dropdown = function(e) {
				var $el = e.data.el;
				$this = $(this),
						$next = $this.next();

				$next.slideToggle();
				$this.toggleClass('open');

				if (!e.data.multiple) {
						$el.find('.scroll-content').not($next).slideUp().removeClass('open');
				};
		}
		var accordion = new Accordion($('.filter-menu'), false);
});

/* Mobile collection filter open */
$(function() {
    $("#pt-nav-toggle").hide();
   var $filte_open_class;
    $filte_open_class = $(".CollectionToolbar__Item--filter");
    $filte_open_class.on("click",function(){
         $('.filter-menu').addClass('pt-expand');
    	 $('.pt-nav-toggle').toggleClass('active');
         $('.filter-menu').find('.scroll-content').slideUp();
    });
});


/* IE 11 Detection code */
$(function() {
  var version = detectIE();
  if (version === false) {
  } else if (version >= 12) {
   //Edge version;
  } else {
    //alert("IE");
    var stickyTop = $('.ie_stick_position').offset().top;
    $(window).on("load resize", function(){
      var width = $(window).width();
       if(width < 768){
          if (windowTop > 1 ){
            $('.CollectionToolbar').addClass("isStick");
          }else{
            $('.CollectionToolbar').removeClass("isStick");
          }
       }
    });

    $(window).scroll(function() {
        var isSticky = $("#isSticky").val();

        var windowTop = $(window).scrollTop();
        var CollectionToolbar = $('.CollectionToolbar').height();
        var Header__Wrapper = $('.Header__Wrapper').height();
        var topPadding = parseFloat(Header__Wrapper)+parseFloat(CollectionToolbar)-15;
        var minus_pad = parseFloat(stickyTop)-parseFloat(Header__Wrapper)-parseFloat(CollectionToolbar)-20;

        var Header__Wrapper_h = $('.Header__Wrapper').outerHeight();
        if (windowTop >= minus_pad) {
           $('.CollectionToolbar').addClass("isStick");
           if(isSticky == "false"){
             $('.CollectionToolbar').css("top",0);
           }else{
             $('.CollectionToolbar').css("top",Header__Wrapper_h);
           }
        } else {
           $('.CollectionToolbar').removeClass("isStick");
           $('.CollectionToolbar').css("top",0);
        }
    });
  }
});
/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}
